import Trigger from './Trigger';

export default class TriggerManager {

    /**
     * @param classes
     */
    constructor(classes) {
        this._triggerClasses = [...classes];
        this._triggerInstances = [];
    }

    /**
     *
     * @param name
     * @param callable
     * @param params
     * @param hash
     */
    async on(name, callable, params = {}, hash = null) {

        let instance = null;

        for (const triggerClass of this._triggerClasses) {
            if (typeof triggerClass === 'function' && triggerClass.TRIGGER_NAME === name) {
                hash = hash || await this._generateHash(triggerClass.TRIGGER_NAME, callable, params);
                instance = new triggerClass(callable, params, hash);
                break;
            }
        }

        this._triggerInstances.push({
            name,
            instance,
            params,
            callable
        });
    }

    async _generateHash(name, callable, params) {
        const encoder = new TextEncoder();
        const input = `${name}_${callable.toString()}_${JSON.stringify(params)}`;
        const data = encoder.encode(input);
        const hashBuffer = await crypto.subtle.digest('SHA-1', data);
        return Array.from(new Uint8Array(hashBuffer))
            .map(b => b.toString(16).padStart(2, '0'))
            .join('');
    }

    async _generateGroupHash(triggers, callable) {
        const encoder = new TextEncoder();
        const input = `${JSON.stringify(triggers)}_${callable.toString()}`;
        const data = encoder.encode(input);
        const hashBuffer = await crypto.subtle.digest('SHA-1', data);
        return Array.from(new Uint8Array(hashBuffer))
            .map(b => b.toString(16).padStart(2, '0'))
            .join('');
    }

    /**
     * @param triggerName
     * @param params
     */
    execute(triggerName, params) {
        for (const {name, instance = null, callable} of this._triggerInstances) {
            if (name === triggerName) {
                if (instance && instance instanceof Trigger) {
                    instance.execute();
                } else if (typeof callable === 'function') {
                    try {
                        callable(params);
                    } catch (e) {
                        console.error(e);
                    }
                }
            }
        }
    }

    /**
     *
     * @param group
     * @param callable
     * @param hash
     */
    async onGroup(group, callable, hash = null) {

        hash = hash || await this._generateGroupHash(group, callable);

        for (const [triggerName, params] of Object.entries(group)) {
            await this.on(triggerName, function (params) {
                callable(params);
            }, params, hash);
        }
    }
}
